/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class CartClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    getCartSummary(  cancelToken?: CancelToken | undefined): Promise<ICartSummary> {
        let url_ = this.baseUrl + "/api/cart/summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCartSummary(_response);
        });
    }

    protected processGetCartSummary(response: AxiosResponse): Promise<ICartSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ICartSummary.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ICartSummary>(<any>null);
    }

    /**
     * @return OK
     */
    updateCartQuantity(args: ProductKeyQuantity , cancelToken?: CancelToken | undefined): Promise<ICartSummary> {
        let url_ = this.baseUrl + "/api/cart/updateQuantity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCartQuantity(_response);
        });
    }

    protected processUpdateCartQuantity(response: AxiosResponse): Promise<ICartSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ICartSummary.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ICartSummary>(<any>null);
    }

    /**
     * @return OK
     */
    copyItemsFromExistingOrder(args: CopyItemsFromExistingOrderArgs , cancelToken?: CancelToken | undefined): Promise<ICartSummary> {
        let url_ = this.baseUrl + "/api/cart/copyItemsFromExistingOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyItemsFromExistingOrder(_response);
        });
    }

    protected processCopyItemsFromExistingOrder(response: AxiosResponse): Promise<ICartSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ICartSummary.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ICartSummary>(<any>null);
    }

    /**
     * @return OK
     */
    addCartQuantity(args: ProductKeyQuantity , cancelToken?: CancelToken | undefined): Promise<ICartSummary> {
        let url_ = this.baseUrl + "/api/cart/addQuantity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCartQuantity(_response);
        });
    }

    protected processAddCartQuantity(response: AxiosResponse): Promise<ICartSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ICartSummary.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ICartSummary>(<any>null);
    }
}

export class OrderlineClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return No Content
     */
    addOrderlineComment(orderLineComment: OrderLineComment , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/cart/orderlines/addComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderLineComment);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrderlineComment(_response);
        });
    }

    protected processAddOrderlineComment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class AuthModel implements IAuthModel {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: IAuthModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["Username"];
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): AuthModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Username"] = this.username;
        data["Password"] = this.password;
        return data; 
    }
}

export interface IAuthModel {
    username?: string | undefined;
    password?: string | undefined;
}

export class ICartSummary implements IICartSummary {
    lines?: IOrderLineSummary[] | undefined;

    constructor(data?: IICartSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Lines"])) {
                this.lines = [] as any;
                for (let item of _data["Lines"])
                    this.lines!.push(IOrderLineSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ICartSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ICartSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lines)) {
            data["Lines"] = [];
            for (let item of this.lines)
                data["Lines"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IICartSummary {
    lines?: IOrderLineSummary[] | undefined;
}

export class IOrderLineSummary implements IIOrderLineSummary {
    quantity?: number | undefined;
    productId?: string | undefined;
    variantId?: string | undefined;
    unitOfMeasure?: string | undefined;
    readonly extraKeys?: { [key: string]: string; } | undefined;

    constructor(data?: IIOrderLineSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["Quantity"];
            this.productId = _data["ProductId"];
            this.variantId = _data["VariantId"];
            this.unitOfMeasure = _data["UnitOfMeasure"];
            if (_data["ExtraKeys"]) {
                (<any>this).extraKeys = {} as any;
                for (let key in _data["ExtraKeys"]) {
                    if (_data["ExtraKeys"].hasOwnProperty(key))
                        (<any>this).extraKeys![key] = _data["ExtraKeys"][key];
                }
            }
        }
    }

    static fromJS(data: any): IOrderLineSummary {
        data = typeof data === 'object' ? data : {};
        let result = new IOrderLineSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Quantity"] = this.quantity;
        data["ProductId"] = this.productId;
        data["VariantId"] = this.variantId;
        data["UnitOfMeasure"] = this.unitOfMeasure;
        if (this.extraKeys) {
            data["ExtraKeys"] = {};
            for (let key in this.extraKeys) {
                if (this.extraKeys.hasOwnProperty(key))
                    data["ExtraKeys"][key] = this.extraKeys[key];
            }
        }
        return data; 
    }
}

export interface IIOrderLineSummary {
    quantity?: number | undefined;
    productId?: string | undefined;
    variantId?: string | undefined;
    unitOfMeasure?: string | undefined;
    extraKeys?: { [key: string]: string; } | undefined;
}

export class ProductKeyQuantity implements IProductKeyQuantity {
    quantity?: number | undefined;
    productId?: string | undefined;
    variantId?: string | undefined;
    unitOfMeasure?: string | undefined;
    languageId?: string | undefined;
    readonly extraKeys?: { [key: string]: string; } | undefined;

    constructor(data?: IProductKeyQuantity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["Quantity"];
            this.productId = _data["ProductId"];
            this.variantId = _data["VariantId"];
            this.unitOfMeasure = _data["UnitOfMeasure"];
            this.languageId = _data["LanguageId"];
            if (_data["ExtraKeys"]) {
                (<any>this).extraKeys = {} as any;
                for (let key in _data["ExtraKeys"]) {
                    if (_data["ExtraKeys"].hasOwnProperty(key))
                        (<any>this).extraKeys![key] = _data["ExtraKeys"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProductKeyQuantity {
        data = typeof data === 'object' ? data : {};
        let result = new ProductKeyQuantity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Quantity"] = this.quantity;
        data["ProductId"] = this.productId;
        data["VariantId"] = this.variantId;
        data["UnitOfMeasure"] = this.unitOfMeasure;
        data["LanguageId"] = this.languageId;
        if (this.extraKeys) {
            data["ExtraKeys"] = {};
            for (let key in this.extraKeys) {
                if (this.extraKeys.hasOwnProperty(key))
                    data["ExtraKeys"][key] = this.extraKeys[key];
            }
        }
        return data; 
    }
}

export interface IProductKeyQuantity {
    quantity?: number | undefined;
    productId?: string | undefined;
    variantId?: string | undefined;
    unitOfMeasure?: string | undefined;
    languageId?: string | undefined;
    extraKeys?: { [key: string]: string; } | undefined;
}

export class CopyItemsFromExistingOrderArgs implements ICopyItemsFromExistingOrderArgs {
    orderId?: string | undefined;
    orderSecret?: string | undefined;
    keys?: string[] | undefined;

    constructor(data?: ICopyItemsFromExistingOrderArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["OrderId"];
            this.orderSecret = _data["OrderSecret"];
            if (Array.isArray(_data["Keys"])) {
                this.keys = [] as any;
                for (let item of _data["Keys"])
                    this.keys!.push(item);
            }
        }
    }

    static fromJS(data: any): CopyItemsFromExistingOrderArgs {
        data = typeof data === 'object' ? data : {};
        let result = new CopyItemsFromExistingOrderArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderId"] = this.orderId;
        data["OrderSecret"] = this.orderSecret;
        if (Array.isArray(this.keys)) {
            data["Keys"] = [];
            for (let item of this.keys)
                data["Keys"].push(item);
        }
        return data; 
    }
}

export interface ICopyItemsFromExistingOrderArgs {
    orderId?: string | undefined;
    orderSecret?: string | undefined;
    keys?: string[] | undefined;
}

export class DataGroup implements IDataGroup {
    id?: string | undefined;
    name?: string | undefined;
    parentId?: string | undefined;
    dataItemTypes?: DataItemType[] | undefined;
    icon?: string | undefined;
    iconColor?: string | undefined;

    constructor(data?: IDataGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.parentId = _data["ParentId"];
            if (Array.isArray(_data["DataItemTypes"])) {
                this.dataItemTypes = [] as any;
                for (let item of _data["DataItemTypes"])
                    this.dataItemTypes!.push(DataItemType.fromJS(item));
            }
            this.icon = _data["Icon"];
            this.iconColor = _data["IconColor"];
        }
    }

    static fromJS(data: any): DataGroup {
        data = typeof data === 'object' ? data : {};
        let result = new DataGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["ParentId"] = this.parentId;
        if (Array.isArray(this.dataItemTypes)) {
            data["DataItemTypes"] = [];
            for (let item of this.dataItemTypes)
                data["DataItemTypes"].push(item.toJSON());
        }
        data["Icon"] = this.icon;
        data["IconColor"] = this.iconColor;
        return data; 
    }
}

export interface IDataGroup {
    id?: string | undefined;
    name?: string | undefined;
    parentId?: string | undefined;
    dataItemTypes?: DataItemType[] | undefined;
    icon?: string | undefined;
    iconColor?: string | undefined;
}

export class DataItemType implements IDataItemType {
    id?: string | undefined;
    dataGroupId?: string | undefined;
    name?: string | undefined;
    providerTypeName?: string | undefined;
    providerParameters?: { [key: string]: string; } | undefined;
    viewMode?: DataItemTypeViewMode | undefined;

    constructor(data?: IDataItemType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.dataGroupId = _data["DataGroupId"];
            this.name = _data["Name"];
            this.providerTypeName = _data["ProviderTypeName"];
            if (_data["ProviderParameters"]) {
                this.providerParameters = {} as any;
                for (let key in _data["ProviderParameters"]) {
                    if (_data["ProviderParameters"].hasOwnProperty(key))
                        this.providerParameters![key] = _data["ProviderParameters"][key];
                }
            }
            this.viewMode = _data["ViewMode"];
        }
    }

    static fromJS(data: any): DataItemType {
        data = typeof data === 'object' ? data : {};
        let result = new DataItemType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["DataGroupId"] = this.dataGroupId;
        data["Name"] = this.name;
        data["ProviderTypeName"] = this.providerTypeName;
        if (this.providerParameters) {
            data["ProviderParameters"] = {};
            for (let key in this.providerParameters) {
                if (this.providerParameters.hasOwnProperty(key))
                    data["ProviderParameters"][key] = this.providerParameters[key];
            }
        }
        data["ViewMode"] = this.viewMode;
        return data; 
    }
}

export interface IDataItemType {
    id?: string | undefined;
    dataGroupId?: string | undefined;
    name?: string | undefined;
    providerTypeName?: string | undefined;
    providerParameters?: { [key: string]: string; } | undefined;
    viewMode?: DataItemTypeViewMode | undefined;
}

export class DataItemSelection implements IDataItemSelection {
    dataItemIds?: string[] | undefined;
    dataItemType?: DataItemType | undefined;

    constructor(data?: IDataItemSelection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["DataItemIds"])) {
                this.dataItemIds = [] as any;
                for (let item of _data["DataItemIds"])
                    this.dataItemIds!.push(item);
            }
            this.dataItemType = _data["DataItemType"] ? DataItemType.fromJS(_data["DataItemType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DataItemSelection {
        data = typeof data === 'object' ? data : {};
        let result = new DataItemSelection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataItemIds)) {
            data["DataItemIds"] = [];
            for (let item of this.dataItemIds)
                data["DataItemIds"].push(item);
        }
        data["DataItemType"] = this.dataItemType ? this.dataItemType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDataItemSelection {
    dataItemIds?: string[] | undefined;
    dataItemType?: DataItemType | undefined;
}

export class DataItem implements IDataItem {
    properties?: { [key: string]: any; } | undefined;
    id?: string | undefined;
    name?: string | undefined;
    parentId?: string | undefined;

    constructor(data?: IDataItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["Properties"]) {
                this.properties = {} as any;
                for (let key in _data["Properties"]) {
                    if (_data["Properties"].hasOwnProperty(key))
                        this.properties![key] = _data["Properties"][key];
                }
            }
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.parentId = _data["ParentId"];
        }
    }

    static fromJS(data: any): DataItem {
        data = typeof data === 'object' ? data : {};
        let result = new DataItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.properties) {
            data["Properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["Properties"][key] = this.properties[key];
            }
        }
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["ParentId"] = this.parentId;
        return data; 
    }
}

export interface IDataItem {
    properties?: { [key: string]: any; } | undefined;
    id?: string | undefined;
    name?: string | undefined;
    parentId?: string | undefined;
}

export class DataItemInfo implements IDataItemInfo {
    checksum?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    parentId?: string | undefined;

    constructor(data?: IDataItemInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checksum = _data["Checksum"];
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.parentId = _data["ParentId"];
        }
    }

    static fromJS(data: any): DataItemInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DataItemInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Checksum"] = this.checksum;
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["ParentId"] = this.parentId;
        return data; 
    }
}

export interface IDataItemInfo {
    checksum?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    parentId?: string | undefined;
}

export class IFacetGroup implements IIFacetGroup {
    fileName?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subType?: string | undefined;
    description?: string | undefined;
    meta?: { [key: string]: string; } | undefined;
    settings?: { [key: string]: string; } | undefined;
    source?: FacetSource | undefined;
    items?: Facet[] | undefined;
    fieldsTermsCount?: { [key: string]: number; } | undefined;

    constructor(data?: IIFacetGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["FileName"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.subType = _data["SubType"];
            this.description = _data["Description"];
            if (_data["Meta"]) {
                this.meta = {} as any;
                for (let key in _data["Meta"]) {
                    if (_data["Meta"].hasOwnProperty(key))
                        this.meta![key] = _data["Meta"][key];
                }
            }
            if (_data["Settings"]) {
                this.settings = {} as any;
                for (let key in _data["Settings"]) {
                    if (_data["Settings"].hasOwnProperty(key))
                        this.settings![key] = _data["Settings"][key];
                }
            }
            this.source = _data["Source"] ? FacetSource.fromJS(_data["Source"]) : <any>undefined;
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(Facet.fromJS(item));
            }
            if (_data["FieldsTermsCount"]) {
                this.fieldsTermsCount = {} as any;
                for (let key in _data["FieldsTermsCount"]) {
                    if (_data["FieldsTermsCount"].hasOwnProperty(key))
                        this.fieldsTermsCount![key] = _data["FieldsTermsCount"][key];
                }
            }
        }
    }

    static fromJS(data: any): IFacetGroup {
        data = typeof data === 'object' ? data : {};
        let result = new IFacetGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FileName"] = this.fileName;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["SubType"] = this.subType;
        data["Description"] = this.description;
        if (this.meta) {
            data["Meta"] = {};
            for (let key in this.meta) {
                if (this.meta.hasOwnProperty(key))
                    data["Meta"][key] = this.meta[key];
            }
        }
        if (this.settings) {
            data["Settings"] = {};
            for (let key in this.settings) {
                if (this.settings.hasOwnProperty(key))
                    data["Settings"][key] = this.settings[key];
            }
        }
        data["Source"] = this.source ? this.source.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        if (this.fieldsTermsCount) {
            data["FieldsTermsCount"] = {};
            for (let key in this.fieldsTermsCount) {
                if (this.fieldsTermsCount.hasOwnProperty(key))
                    data["FieldsTermsCount"][key] = this.fieldsTermsCount[key];
            }
        }
        return data; 
    }
}

export interface IIFacetGroup {
    fileName?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subType?: string | undefined;
    description?: string | undefined;
    meta?: { [key: string]: string; } | undefined;
    settings?: { [key: string]: string; } | undefined;
    source?: FacetSource | undefined;
    items?: Facet[] | undefined;
    fieldsTermsCount?: { [key: string]: number; } | undefined;
}

export class FacetSource implements IFacetSource {
    repository?: string | undefined;
    item?: string | undefined;

    constructor(data?: IFacetSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repository = _data["Repository"];
            this.item = _data["Item"];
        }
    }

    static fromJS(data: any): FacetSource {
        data = typeof data === 'object' ? data : {};
        let result = new FacetSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Repository"] = this.repository;
        data["Item"] = this.item;
        return data; 
    }
}

export interface IFacetSource {
    repository?: string | undefined;
    item?: string | undefined;
}

export class Facet implements IFacet {
    name?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    queryParameter?: string | undefined;
    field?: string | undefined;
    options?: FacetOption[] | undefined;
    renderType?: FacetRenderType | undefined;
    source?: string | undefined;
    readonly visibility?: FacetVisibility | undefined;

    constructor(data?: IFacet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.typeName = _data["TypeName"];
            this.queryParameter = _data["QueryParameter"];
            this.field = _data["Field"];
            if (Array.isArray(_data["Options"])) {
                this.options = [] as any;
                for (let item of _data["Options"])
                    this.options!.push(FacetOption.fromJS(item));
            }
            this.renderType = _data["RenderType"] ? FacetRenderType.fromJS(_data["RenderType"]) : <any>undefined;
            this.source = _data["Source"];
            (<any>this).visibility = _data["Visibility"] ? FacetVisibility.fromJS(_data["Visibility"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Facet {
        data = typeof data === 'object' ? data : {};
        let result = new Facet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["TypeName"] = this.typeName;
        data["QueryParameter"] = this.queryParameter;
        data["Field"] = this.field;
        if (Array.isArray(this.options)) {
            data["Options"] = [];
            for (let item of this.options)
                data["Options"].push(item.toJSON());
        }
        data["RenderType"] = this.renderType ? this.renderType.toJSON() : <any>undefined;
        data["Source"] = this.source;
        data["Visibility"] = this.visibility ? this.visibility.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFacet {
    name?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    queryParameter?: string | undefined;
    field?: string | undefined;
    options?: FacetOption[] | undefined;
    renderType?: FacetRenderType | undefined;
    source?: string | undefined;
    visibility?: FacetVisibility | undefined;
}

export class FacetOption implements IFacetOption {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IFacetOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): FacetOption {
        data = typeof data === 'object' ? data : {};
        let result = new FacetOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Value"] = this.value;
        return data; 
    }
}

export interface IFacetOption {
    name?: string | undefined;
    value?: string | undefined;
}

export class FacetRenderType implements IFacetRenderType {
    name?: string | undefined;
    systemName?: string | undefined;

    constructor(data?: IFacetRenderType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.systemName = _data["SystemName"];
        }
    }

    static fromJS(data: any): FacetRenderType {
        data = typeof data === 'object' ? data : {};
        let result = new FacetRenderType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["SystemName"] = this.systemName;
        return data; 
    }
}

export interface IFacetRenderType {
    name?: string | undefined;
    systemName?: string | undefined;
}

export class FacetVisibility implements IFacetVisibility {
    status?: FacetVisibilityStatus | undefined;
    queryParameter?: string | undefined;
    condition?: FacetVisibilityCondition | undefined;
    matchValue?: string | undefined;

    constructor(data?: IFacetVisibility) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["Status"];
            this.queryParameter = _data["QueryParameter"];
            this.condition = _data["Condition"];
            this.matchValue = _data["MatchValue"];
        }
    }

    static fromJS(data: any): FacetVisibility {
        data = typeof data === 'object' ? data : {};
        let result = new FacetVisibility();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Status"] = this.status;
        data["QueryParameter"] = this.queryParameter;
        data["Condition"] = this.condition;
        data["MatchValue"] = this.matchValue;
        return data; 
    }
}

export interface IFacetVisibility {
    status?: FacetVisibilityStatus | undefined;
    queryParameter?: string | undefined;
    condition?: FacetVisibilityCondition | undefined;
    matchValue?: string | undefined;
}

export class FeedContextConfiguration implements IFeedContextConfiguration {
    languageId?: string | undefined;
    currencyId?: string | undefined;
    shopId?: string | undefined;

    constructor(data?: IFeedContextConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["LanguageId"];
            this.currencyId = _data["CurrencyId"];
            this.shopId = _data["ShopId"];
        }
    }

    static fromJS(data: any): FeedContextConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new FeedContextConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LanguageId"] = this.languageId;
        data["CurrencyId"] = this.currencyId;
        data["ShopId"] = this.shopId;
        return data; 
    }
}

export interface IFeedContextConfiguration {
    languageId?: string | undefined;
    currencyId?: string | undefined;
    shopId?: string | undefined;
}

export class IIndex implements IIIndex {
    fileName?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subType?: string | undefined;
    description?: string | undefined;
    meta?: { [key: string]: string; } | undefined;
    settings?: { [key: string]: string; } | undefined;
    balancer?: IIndexBalancer | undefined;
    instances?: { [key: string]: IIndexProvider; } | undefined;
    builds?: { [key: string]: IIndexBuilder; } | undefined;
    schema?: SchemaDefinition | undefined;

    constructor(data?: IIIndex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["FileName"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.subType = _data["SubType"];
            this.description = _data["Description"];
            if (_data["Meta"]) {
                this.meta = {} as any;
                for (let key in _data["Meta"]) {
                    if (_data["Meta"].hasOwnProperty(key))
                        this.meta![key] = _data["Meta"][key];
                }
            }
            if (_data["Settings"]) {
                this.settings = {} as any;
                for (let key in _data["Settings"]) {
                    if (_data["Settings"].hasOwnProperty(key))
                        this.settings![key] = _data["Settings"][key];
                }
            }
            this.balancer = _data["Balancer"] ? IIndexBalancer.fromJS(_data["Balancer"]) : <any>undefined;
            if (_data["Instances"]) {
                this.instances = {} as any;
                for (let key in _data["Instances"]) {
                    if (_data["Instances"].hasOwnProperty(key))
                        this.instances![key] = _data["Instances"][key] ? IIndexProvider.fromJS(_data["Instances"][key]) : new IIndexProvider();
                }
            }
            if (_data["Builds"]) {
                this.builds = {} as any;
                for (let key in _data["Builds"]) {
                    if (_data["Builds"].hasOwnProperty(key))
                        this.builds![key] = _data["Builds"][key] ? IIndexBuilder.fromJS(_data["Builds"][key]) : new IIndexBuilder();
                }
            }
            this.schema = _data["Schema"] ? SchemaDefinition.fromJS(_data["Schema"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IIndex {
        data = typeof data === 'object' ? data : {};
        let result = new IIndex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FileName"] = this.fileName;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["SubType"] = this.subType;
        data["Description"] = this.description;
        if (this.meta) {
            data["Meta"] = {};
            for (let key in this.meta) {
                if (this.meta.hasOwnProperty(key))
                    data["Meta"][key] = this.meta[key];
            }
        }
        if (this.settings) {
            data["Settings"] = {};
            for (let key in this.settings) {
                if (this.settings.hasOwnProperty(key))
                    data["Settings"][key] = this.settings[key];
            }
        }
        data["Balancer"] = this.balancer ? this.balancer.toJSON() : <any>undefined;
        if (this.instances) {
            data["Instances"] = {};
            for (let key in this.instances) {
                if (this.instances.hasOwnProperty(key))
                    data["Instances"][key] = this.instances[key] ? this.instances[key].toJSON() : <any>undefined;
            }
        }
        if (this.builds) {
            data["Builds"] = {};
            for (let key in this.builds) {
                if (this.builds.hasOwnProperty(key))
                    data["Builds"][key] = this.builds[key] ? this.builds[key].toJSON() : <any>undefined;
            }
        }
        data["Schema"] = this.schema ? this.schema.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IIIndex {
    fileName?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subType?: string | undefined;
    description?: string | undefined;
    meta?: { [key: string]: string; } | undefined;
    settings?: { [key: string]: string; } | undefined;
    balancer?: IIndexBalancer | undefined;
    instances?: { [key: string]: IIndexProvider; } | undefined;
    builds?: { [key: string]: IIndexBuilder; } | undefined;
    schema?: SchemaDefinition | undefined;
}

export class IIndexBalancer implements IIIndexBalancer {
    index?: IIndex | undefined;
    readonly type?: string | undefined;

    constructor(data?: IIIndexBalancer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["Index"] ? IIndex.fromJS(_data["Index"]) : <any>undefined;
            (<any>this).type = _data["Type"];
        }
    }

    static fromJS(data: any): IIndexBalancer {
        data = typeof data === 'object' ? data : {};
        let result = new IIndexBalancer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Index"] = this.index ? this.index.toJSON() : <any>undefined;
        data["Type"] = this.type;
        return data; 
    }
}

export interface IIIndexBalancer {
    index?: IIndex | undefined;
    type?: string | undefined;
}

export class IIndexProvider implements IIIndexProvider {
    name?: string | undefined;
    type?: string | undefined;
    settings?: { [key: string]: string; } | undefined;
    readonly isAvailable?: boolean | undefined;

    constructor(data?: IIIndexProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.type = _data["Type"];
            if (_data["Settings"]) {
                this.settings = {} as any;
                for (let key in _data["Settings"]) {
                    if (_data["Settings"].hasOwnProperty(key))
                        this.settings![key] = _data["Settings"][key];
                }
            }
            (<any>this).isAvailable = _data["IsAvailable"];
        }
    }

    static fromJS(data: any): IIndexProvider {
        data = typeof data === 'object' ? data : {};
        let result = new IIndexProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Type"] = this.type;
        if (this.settings) {
            data["Settings"] = {};
            for (let key in this.settings) {
                if (this.settings.hasOwnProperty(key))
                    data["Settings"][key] = this.settings[key];
            }
        }
        data["IsAvailable"] = this.isAvailable;
        return data; 
    }
}

export interface IIIndexProvider {
    name?: string | undefined;
    type?: string | undefined;
    settings?: { [key: string]: string; } | undefined;
    isAvailable?: boolean | undefined;
}

export class IIndexBuilder implements IIIndexBuilder {
    name?: string | undefined;
    type?: string | undefined;
    action?: string | undefined;
    settings?: { [key: string]: string; } | undefined;
    readonly defaultSettings?: { [key: string]: any; } | undefined;
    meta?: { [key: string]: string; } | undefined;
    schema?: SchemaDefinition | undefined;
    readonly supportedActions?: string[] | undefined;
    extenders?: IIndexBuilderExtenderOfIIndexBuilder[] | undefined;
    notification?: IIndexBuilderNotification | undefined;

    constructor(data?: IIIndexBuilder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.action = _data["Action"];
            if (_data["Settings"]) {
                this.settings = {} as any;
                for (let key in _data["Settings"]) {
                    if (_data["Settings"].hasOwnProperty(key))
                        this.settings![key] = _data["Settings"][key];
                }
            }
            if (_data["DefaultSettings"]) {
                (<any>this).defaultSettings = {} as any;
                for (let key in _data["DefaultSettings"]) {
                    if (_data["DefaultSettings"].hasOwnProperty(key))
                        (<any>this).defaultSettings![key] = _data["DefaultSettings"][key];
                }
            }
            if (_data["Meta"]) {
                this.meta = {} as any;
                for (let key in _data["Meta"]) {
                    if (_data["Meta"].hasOwnProperty(key))
                        this.meta![key] = _data["Meta"][key];
                }
            }
            this.schema = _data["Schema"] ? SchemaDefinition.fromJS(_data["Schema"]) : <any>undefined;
            if (Array.isArray(_data["SupportedActions"])) {
                (<any>this).supportedActions = [] as any;
                for (let item of _data["SupportedActions"])
                    (<any>this).supportedActions!.push(item);
            }
            if (Array.isArray(_data["Extenders"])) {
                this.extenders = [] as any;
                for (let item of _data["Extenders"])
                    this.extenders!.push(IIndexBuilderExtenderOfIIndexBuilder.fromJS(item));
            }
            this.notification = _data["Notification"] ? IIndexBuilderNotification.fromJS(_data["Notification"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IIndexBuilder {
        data = typeof data === 'object' ? data : {};
        let result = new IIndexBuilder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["Action"] = this.action;
        if (this.settings) {
            data["Settings"] = {};
            for (let key in this.settings) {
                if (this.settings.hasOwnProperty(key))
                    data["Settings"][key] = this.settings[key];
            }
        }
        if (this.defaultSettings) {
            data["DefaultSettings"] = {};
            for (let key in this.defaultSettings) {
                if (this.defaultSettings.hasOwnProperty(key))
                    data["DefaultSettings"][key] = this.defaultSettings[key];
            }
        }
        if (this.meta) {
            data["Meta"] = {};
            for (let key in this.meta) {
                if (this.meta.hasOwnProperty(key))
                    data["Meta"][key] = this.meta[key];
            }
        }
        data["Schema"] = this.schema ? this.schema.toJSON() : <any>undefined;
        if (Array.isArray(this.supportedActions)) {
            data["SupportedActions"] = [];
            for (let item of this.supportedActions)
                data["SupportedActions"].push(item);
        }
        if (Array.isArray(this.extenders)) {
            data["Extenders"] = [];
            for (let item of this.extenders)
                data["Extenders"].push(item.toJSON());
        }
        data["Notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IIIndexBuilder {
    name?: string | undefined;
    type?: string | undefined;
    action?: string | undefined;
    settings?: { [key: string]: string; } | undefined;
    defaultSettings?: { [key: string]: any; } | undefined;
    meta?: { [key: string]: string; } | undefined;
    schema?: SchemaDefinition | undefined;
    supportedActions?: string[] | undefined;
    extenders?: IIndexBuilderExtenderOfIIndexBuilder[] | undefined;
    notification?: IIndexBuilderNotification | undefined;
}

export class SchemaDefinition implements ISchemaDefinition {
    fieldTypes?: FieldTypeDefinition[] | undefined;
    fields?: FieldDefinitionBase[] | undefined;
    fieldsFromIndexDefinition?: FieldDefinitionBase[] | undefined;

    constructor(data?: ISchemaDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["FieldTypes"])) {
                this.fieldTypes = [] as any;
                for (let item of _data["FieldTypes"])
                    this.fieldTypes!.push(FieldTypeDefinition.fromJS(item));
            }
            if (Array.isArray(_data["Fields"])) {
                this.fields = [] as any;
                for (let item of _data["Fields"])
                    this.fields!.push(FieldDefinitionBase.fromJS(item));
            }
            if (Array.isArray(_data["FieldsFromIndexDefinition"])) {
                this.fieldsFromIndexDefinition = [] as any;
                for (let item of _data["FieldsFromIndexDefinition"])
                    this.fieldsFromIndexDefinition!.push(FieldDefinitionBase.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchemaDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new SchemaDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fieldTypes)) {
            data["FieldTypes"] = [];
            for (let item of this.fieldTypes)
                data["FieldTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.fields)) {
            data["Fields"] = [];
            for (let item of this.fields)
                data["Fields"].push(item.toJSON());
        }
        if (Array.isArray(this.fieldsFromIndexDefinition)) {
            data["FieldsFromIndexDefinition"] = [];
            for (let item of this.fieldsFromIndexDefinition)
                data["FieldsFromIndexDefinition"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISchemaDefinition {
    fieldTypes?: FieldTypeDefinition[] | undefined;
    fields?: FieldDefinitionBase[] | undefined;
    fieldsFromIndexDefinition?: FieldDefinitionBase[] | undefined;
}

export class IIndexBuilderExtenderOfIIndexBuilder implements IIIndexBuilderExtenderOfIIndexBuilder {

    constructor(data?: IIIndexBuilderExtenderOfIIndexBuilder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IIndexBuilderExtenderOfIIndexBuilder {
        data = typeof data === 'object' ? data : {};
        let result = new IIndexBuilderExtenderOfIIndexBuilder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IIIndexBuilderExtenderOfIIndexBuilder {
}

export class IIndexBuilderNotification implements IIIndexBuilderNotification {
    senderName?: string | undefined;
    senderEmail?: string | undefined;
    recipients?: string[] | undefined;
    subject?: string | undefined;
    template?: string | undefined;
    sendLog?: boolean | undefined;
    notificationType?: IIndexBuilderNotificationNotificationType | undefined;

    constructor(data?: IIIndexBuilderNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.senderName = _data["SenderName"];
            this.senderEmail = _data["SenderEmail"];
            if (Array.isArray(_data["Recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["Recipients"])
                    this.recipients!.push(item);
            }
            this.subject = _data["Subject"];
            this.template = _data["Template"];
            this.sendLog = _data["SendLog"];
            this.notificationType = _data["NotificationType"];
        }
    }

    static fromJS(data: any): IIndexBuilderNotification {
        data = typeof data === 'object' ? data : {};
        let result = new IIndexBuilderNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SenderName"] = this.senderName;
        data["SenderEmail"] = this.senderEmail;
        if (Array.isArray(this.recipients)) {
            data["Recipients"] = [];
            for (let item of this.recipients)
                data["Recipients"].push(item);
        }
        data["Subject"] = this.subject;
        data["Template"] = this.template;
        data["SendLog"] = this.sendLog;
        data["NotificationType"] = this.notificationType;
        return data; 
    }
}

export interface IIIndexBuilderNotification {
    senderName?: string | undefined;
    senderEmail?: string | undefined;
    recipients?: string[] | undefined;
    subject?: string | undefined;
    template?: string | undefined;
    sendLog?: boolean | undefined;
    notificationType?: IIndexBuilderNotificationNotificationType | undefined;
}

export class FieldTypeDefinition implements IFieldTypeDefinition {
    name?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    analyzers?: { [key: string]: string; } | undefined;
    boost?: string | undefined;

    constructor(data?: IFieldTypeDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.typeName = _data["TypeName"];
            if (_data["Analyzers"]) {
                this.analyzers = {} as any;
                for (let key in _data["Analyzers"]) {
                    if (_data["Analyzers"].hasOwnProperty(key))
                        this.analyzers![key] = _data["Analyzers"][key];
                }
            }
            this.boost = _data["Boost"];
        }
    }

    static fromJS(data: any): FieldTypeDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new FieldTypeDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["TypeName"] = this.typeName;
        if (this.analyzers) {
            data["Analyzers"] = {};
            for (let key in this.analyzers) {
                if (this.analyzers.hasOwnProperty(key))
                    data["Analyzers"][key] = this.analyzers[key];
            }
        }
        data["Boost"] = this.boost;
        return data; 
    }
}

export interface IFieldTypeDefinition {
    name?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    analyzers?: { [key: string]: string; } | undefined;
    boost?: string | undefined;
}

export class FieldDefinitionBase implements IFieldDefinitionBase {
    name?: string | undefined;
    systemName?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    analyzer?: string | undefined;
    analyzerTypeName?: string | undefined;
    boost?: string | undefined;
    stored?: boolean | undefined;
    indexed?: boolean | undefined;
    analyzed?: boolean | undefined;
    group?: string | undefined;
    isFieldFromSchemaExtender?: boolean | undefined;
    readonly isNumeric?: boolean | undefined;

    constructor(data?: IFieldDefinitionBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.systemName = _data["SystemName"];
            this.type = _data["Type"];
            this.typeName = _data["TypeName"];
            this.analyzer = _data["Analyzer"];
            this.analyzerTypeName = _data["AnalyzerTypeName"];
            this.boost = _data["Boost"];
            this.stored = _data["Stored"];
            this.indexed = _data["Indexed"];
            this.analyzed = _data["Analyzed"];
            this.group = _data["Group"];
            this.isFieldFromSchemaExtender = _data["IsFieldFromSchemaExtender"];
            (<any>this).isNumeric = _data["IsNumeric"];
        }
    }

    static fromJS(data: any): FieldDefinitionBase {
        data = typeof data === 'object' ? data : {};
        let result = new FieldDefinitionBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["SystemName"] = this.systemName;
        data["Type"] = this.type;
        data["TypeName"] = this.typeName;
        data["Analyzer"] = this.analyzer;
        data["AnalyzerTypeName"] = this.analyzerTypeName;
        data["Boost"] = this.boost;
        data["Stored"] = this.stored;
        data["Indexed"] = this.indexed;
        data["Analyzed"] = this.analyzed;
        data["Group"] = this.group;
        data["IsFieldFromSchemaExtender"] = this.isFieldFromSchemaExtender;
        data["IsNumeric"] = this.isNumeric;
        return data; 
    }
}

export interface IFieldDefinitionBase {
    name?: string | undefined;
    systemName?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    analyzer?: string | undefined;
    analyzerTypeName?: string | undefined;
    boost?: string | undefined;
    stored?: boolean | undefined;
    indexed?: boolean | undefined;
    analyzed?: boolean | undefined;
    group?: string | undefined;
    isFieldFromSchemaExtender?: boolean | undefined;
    isNumeric?: boolean | undefined;
}

export class OrderLineComment implements IOrderLineComment {
    porterId?: string | undefined;
    productNumber?: string | undefined;
    comment?: string | undefined;

    constructor(data?: IOrderLineComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.porterId = _data["PorterId"];
            this.productNumber = _data["ProductNumber"];
            this.comment = _data["Comment"];
        }
    }

    static fromJS(data: any): OrderLineComment {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLineComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PorterId"] = this.porterId;
        data["ProductNumber"] = this.productNumber;
        data["Comment"] = this.comment;
        return data; 
    }
}

export interface IOrderLineComment {
    porterId?: string | undefined;
    productNumber?: string | undefined;
    comment?: string | undefined;
}

export class ProductViewModelSettings implements IProductViewModelSettings {
    priceSettings?: PriceViewModelSettings | undefined;
    productRelatedSettings?: ProductRelatedViewModelSettings | undefined;
    variantCombinationSettings?: VariantCombinationViewModelSettings | undefined;
    mediaSettings?: MediaViewModelSettings | undefined;
    manufacturerSettings?: ManufacturerViewModelSettings | undefined;
    categoryFieldSettings?: CategoryFieldViewModelSetting | undefined;
    productFieldSettings?: FieldValueViewModelSetting | undefined;
    userId?: number | undefined;
    currencyCode?: string | undefined;
    countryCode?: string | undefined;
    shopId?: string | undefined;
    languageId?: string | undefined;
    filledProperties?: string[] | undefined;

    constructor(data?: IProductViewModelSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priceSettings = _data["PriceSettings"] ? PriceViewModelSettings.fromJS(_data["PriceSettings"]) : <any>undefined;
            this.productRelatedSettings = _data["ProductRelatedSettings"] ? ProductRelatedViewModelSettings.fromJS(_data["ProductRelatedSettings"]) : <any>undefined;
            this.variantCombinationSettings = _data["VariantCombinationSettings"] ? VariantCombinationViewModelSettings.fromJS(_data["VariantCombinationSettings"]) : <any>undefined;
            this.mediaSettings = _data["MediaSettings"] ? MediaViewModelSettings.fromJS(_data["MediaSettings"]) : <any>undefined;
            this.manufacturerSettings = _data["ManufacturerSettings"] ? ManufacturerViewModelSettings.fromJS(_data["ManufacturerSettings"]) : <any>undefined;
            this.categoryFieldSettings = _data["CategoryFieldSettings"] ? CategoryFieldViewModelSetting.fromJS(_data["CategoryFieldSettings"]) : <any>undefined;
            this.productFieldSettings = _data["ProductFieldSettings"] ? FieldValueViewModelSetting.fromJS(_data["ProductFieldSettings"]) : <any>undefined;
            this.userId = _data["UserId"];
            this.currencyCode = _data["CurrencyCode"];
            this.countryCode = _data["CountryCode"];
            this.shopId = _data["ShopId"];
            this.languageId = _data["LanguageId"];
            if (Array.isArray(_data["FilledProperties"])) {
                this.filledProperties = [] as any;
                for (let item of _data["FilledProperties"])
                    this.filledProperties!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductViewModelSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ProductViewModelSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PriceSettings"] = this.priceSettings ? this.priceSettings.toJSON() : <any>undefined;
        data["ProductRelatedSettings"] = this.productRelatedSettings ? this.productRelatedSettings.toJSON() : <any>undefined;
        data["VariantCombinationSettings"] = this.variantCombinationSettings ? this.variantCombinationSettings.toJSON() : <any>undefined;
        data["MediaSettings"] = this.mediaSettings ? this.mediaSettings.toJSON() : <any>undefined;
        data["ManufacturerSettings"] = this.manufacturerSettings ? this.manufacturerSettings.toJSON() : <any>undefined;
        data["CategoryFieldSettings"] = this.categoryFieldSettings ? this.categoryFieldSettings.toJSON() : <any>undefined;
        data["ProductFieldSettings"] = this.productFieldSettings ? this.productFieldSettings.toJSON() : <any>undefined;
        data["UserId"] = this.userId;
        data["CurrencyCode"] = this.currencyCode;
        data["CountryCode"] = this.countryCode;
        data["ShopId"] = this.shopId;
        data["LanguageId"] = this.languageId;
        if (Array.isArray(this.filledProperties)) {
            data["FilledProperties"] = [];
            for (let item of this.filledProperties)
                data["FilledProperties"].push(item);
        }
        return data; 
    }
}

export interface IProductViewModelSettings {
    priceSettings?: PriceViewModelSettings | undefined;
    productRelatedSettings?: ProductRelatedViewModelSettings | undefined;
    variantCombinationSettings?: VariantCombinationViewModelSettings | undefined;
    mediaSettings?: MediaViewModelSettings | undefined;
    manufacturerSettings?: ManufacturerViewModelSettings | undefined;
    categoryFieldSettings?: CategoryFieldViewModelSetting | undefined;
    productFieldSettings?: FieldValueViewModelSetting | undefined;
    userId?: number | undefined;
    currencyCode?: string | undefined;
    countryCode?: string | undefined;
    shopId?: string | undefined;
    languageId?: string | undefined;
    filledProperties?: string[] | undefined;
}

export class PriceViewModelSettings implements IPriceViewModelSettings {
    userId?: number | undefined;
    currencyCode?: string | undefined;
    countryCode?: string | undefined;
    shopId?: string | undefined;
    languageId?: string | undefined;
    filledProperties?: string[] | undefined;

    constructor(data?: IPriceViewModelSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.currencyCode = _data["CurrencyCode"];
            this.countryCode = _data["CountryCode"];
            this.shopId = _data["ShopId"];
            this.languageId = _data["LanguageId"];
            if (Array.isArray(_data["FilledProperties"])) {
                this.filledProperties = [] as any;
                for (let item of _data["FilledProperties"])
                    this.filledProperties!.push(item);
            }
        }
    }

    static fromJS(data: any): PriceViewModelSettings {
        data = typeof data === 'object' ? data : {};
        let result = new PriceViewModelSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["CurrencyCode"] = this.currencyCode;
        data["CountryCode"] = this.countryCode;
        data["ShopId"] = this.shopId;
        data["LanguageId"] = this.languageId;
        if (Array.isArray(this.filledProperties)) {
            data["FilledProperties"] = [];
            for (let item of this.filledProperties)
                data["FilledProperties"].push(item);
        }
        return data; 
    }
}

export interface IPriceViewModelSettings {
    userId?: number | undefined;
    currencyCode?: string | undefined;
    countryCode?: string | undefined;
    shopId?: string | undefined;
    languageId?: string | undefined;
    filledProperties?: string[] | undefined;
}

export class ProductRelatedViewModelSettings implements IProductRelatedViewModelSettings {
    languageId?: string | undefined;
    filledProperties?: string[] | undefined;

    constructor(data?: IProductRelatedViewModelSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["LanguageId"];
            if (Array.isArray(_data["FilledProperties"])) {
                this.filledProperties = [] as any;
                for (let item of _data["FilledProperties"])
                    this.filledProperties!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductRelatedViewModelSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ProductRelatedViewModelSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LanguageId"] = this.languageId;
        if (Array.isArray(this.filledProperties)) {
            data["FilledProperties"] = [];
            for (let item of this.filledProperties)
                data["FilledProperties"].push(item);
        }
        return data; 
    }
}

export interface IProductRelatedViewModelSettings {
    languageId?: string | undefined;
    filledProperties?: string[] | undefined;
}

export class VariantCombinationViewModelSettings implements IVariantCombinationViewModelSettings {
    languageId?: string | undefined;
    filledProperties?: string[] | undefined;

    constructor(data?: IVariantCombinationViewModelSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["LanguageId"];
            if (Array.isArray(_data["FilledProperties"])) {
                this.filledProperties = [] as any;
                for (let item of _data["FilledProperties"])
                    this.filledProperties!.push(item);
            }
        }
    }

    static fromJS(data: any): VariantCombinationViewModelSettings {
        data = typeof data === 'object' ? data : {};
        let result = new VariantCombinationViewModelSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LanguageId"] = this.languageId;
        if (Array.isArray(this.filledProperties)) {
            data["FilledProperties"] = [];
            for (let item of this.filledProperties)
                data["FilledProperties"].push(item);
        }
        return data; 
    }
}

export interface IVariantCombinationViewModelSettings {
    languageId?: string | undefined;
    filledProperties?: string[] | undefined;
}

export class MediaViewModelSettings implements IMediaViewModelSettings {
    includeNonexistentImages?: boolean | undefined;
    filledProperties?: string[] | undefined;

    constructor(data?: IMediaViewModelSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeNonexistentImages = _data["IncludeNonexistentImages"];
            if (Array.isArray(_data["FilledProperties"])) {
                this.filledProperties = [] as any;
                for (let item of _data["FilledProperties"])
                    this.filledProperties!.push(item);
            }
        }
    }

    static fromJS(data: any): MediaViewModelSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MediaViewModelSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IncludeNonexistentImages"] = this.includeNonexistentImages;
        if (Array.isArray(this.filledProperties)) {
            data["FilledProperties"] = [];
            for (let item of this.filledProperties)
                data["FilledProperties"].push(item);
        }
        return data; 
    }
}

export interface IMediaViewModelSettings {
    includeNonexistentImages?: boolean | undefined;
    filledProperties?: string[] | undefined;
}

export class ManufacturerViewModelSettings implements IManufacturerViewModelSettings {
    filledProperties?: string[] | undefined;

    constructor(data?: IManufacturerViewModelSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["FilledProperties"])) {
                this.filledProperties = [] as any;
                for (let item of _data["FilledProperties"])
                    this.filledProperties!.push(item);
            }
        }
    }

    static fromJS(data: any): ManufacturerViewModelSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerViewModelSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.filledProperties)) {
            data["FilledProperties"] = [];
            for (let item of this.filledProperties)
                data["FilledProperties"].push(item);
        }
        return data; 
    }
}

export interface IManufacturerViewModelSettings {
    filledProperties?: string[] | undefined;
}

export class CategoryFieldViewModelSetting implements ICategoryFieldViewModelSetting {
    fieldsToShow?: string[] | undefined;
    filledProperties?: string[] | undefined;

    constructor(data?: ICategoryFieldViewModelSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["FieldsToShow"])) {
                this.fieldsToShow = [] as any;
                for (let item of _data["FieldsToShow"])
                    this.fieldsToShow!.push(item);
            }
            if (Array.isArray(_data["FilledProperties"])) {
                this.filledProperties = [] as any;
                for (let item of _data["FilledProperties"])
                    this.filledProperties!.push(item);
            }
        }
    }

    static fromJS(data: any): CategoryFieldViewModelSetting {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryFieldViewModelSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fieldsToShow)) {
            data["FieldsToShow"] = [];
            for (let item of this.fieldsToShow)
                data["FieldsToShow"].push(item);
        }
        if (Array.isArray(this.filledProperties)) {
            data["FilledProperties"] = [];
            for (let item of this.filledProperties)
                data["FilledProperties"].push(item);
        }
        return data; 
    }
}

export interface ICategoryFieldViewModelSetting {
    fieldsToShow?: string[] | undefined;
    filledProperties?: string[] | undefined;
}

export class FieldValueViewModelSetting implements IFieldValueViewModelSetting {
    fieldsToShow?: string[] | undefined;
    filledProperties?: string[] | undefined;

    constructor(data?: IFieldValueViewModelSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["FieldsToShow"])) {
                this.fieldsToShow = [] as any;
                for (let item of _data["FieldsToShow"])
                    this.fieldsToShow!.push(item);
            }
            if (Array.isArray(_data["FilledProperties"])) {
                this.filledProperties = [] as any;
                for (let item of _data["FilledProperties"])
                    this.filledProperties!.push(item);
            }
        }
    }

    static fromJS(data: any): FieldValueViewModelSetting {
        data = typeof data === 'object' ? data : {};
        let result = new FieldValueViewModelSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fieldsToShow)) {
            data["FieldsToShow"] = [];
            for (let item of this.fieldsToShow)
                data["FieldsToShow"].push(item);
        }
        if (Array.isArray(this.filledProperties)) {
            data["FilledProperties"] = [];
            for (let item of this.filledProperties)
                data["FilledProperties"].push(item);
        }
        return data; 
    }
}

export interface IFieldValueViewModelSetting {
    fieldsToShow?: string[] | undefined;
    filledProperties?: string[] | undefined;
}

export class IQuery implements IIQuery {
    iD?: string | undefined;
    fileName?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subType?: string | undefined;
    description?: string | undefined;
    meta?: { [key: string]: string; } | undefined;
    settings?: { [key: string]: string; } | undefined;
    sortOrder?: SortInfo[] | undefined;
    parameters?: QueryParameter[] | undefined;
    imports?: QueryImport[] | undefined;
    references?: QueryReference[] | undefined;
    source?: QuerySource | undefined;
    expression?: Expression | undefined;
    viewFields?: ViewField[] | undefined;
    viewLanguages?: Language[] | undefined;
    completionRules?: number[] | undefined;
    completionLanguages?: Language[] | undefined;

    constructor(data?: IIQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iD = _data["ID"];
            this.fileName = _data["FileName"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.subType = _data["SubType"];
            this.description = _data["Description"];
            if (_data["Meta"]) {
                this.meta = {} as any;
                for (let key in _data["Meta"]) {
                    if (_data["Meta"].hasOwnProperty(key))
                        this.meta![key] = _data["Meta"][key];
                }
            }
            if (_data["Settings"]) {
                this.settings = {} as any;
                for (let key in _data["Settings"]) {
                    if (_data["Settings"].hasOwnProperty(key))
                        this.settings![key] = _data["Settings"][key];
                }
            }
            if (Array.isArray(_data["SortOrder"])) {
                this.sortOrder = [] as any;
                for (let item of _data["SortOrder"])
                    this.sortOrder!.push(SortInfo.fromJS(item));
            }
            if (Array.isArray(_data["Parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["Parameters"])
                    this.parameters!.push(QueryParameter.fromJS(item));
            }
            if (Array.isArray(_data["Imports"])) {
                this.imports = [] as any;
                for (let item of _data["Imports"])
                    this.imports!.push(QueryImport.fromJS(item));
            }
            if (Array.isArray(_data["References"])) {
                this.references = [] as any;
                for (let item of _data["References"])
                    this.references!.push(QueryReference.fromJS(item));
            }
            this.source = _data["Source"] ? QuerySource.fromJS(_data["Source"]) : <any>undefined;
            this.expression = _data["Expression"] ? Expression.fromJS(_data["Expression"]) : <any>undefined;
            if (Array.isArray(_data["ViewFields"])) {
                this.viewFields = [] as any;
                for (let item of _data["ViewFields"])
                    this.viewFields!.push(ViewField.fromJS(item));
            }
            if (Array.isArray(_data["ViewLanguages"])) {
                this.viewLanguages = [] as any;
                for (let item of _data["ViewLanguages"])
                    this.viewLanguages!.push(Language.fromJS(item));
            }
            if (Array.isArray(_data["CompletionRules"])) {
                this.completionRules = [] as any;
                for (let item of _data["CompletionRules"])
                    this.completionRules!.push(item);
            }
            if (Array.isArray(_data["CompletionLanguages"])) {
                this.completionLanguages = [] as any;
                for (let item of _data["CompletionLanguages"])
                    this.completionLanguages!.push(Language.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IQuery {
        data = typeof data === 'object' ? data : {};
        let result = new IQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ID"] = this.iD;
        data["FileName"] = this.fileName;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["SubType"] = this.subType;
        data["Description"] = this.description;
        if (this.meta) {
            data["Meta"] = {};
            for (let key in this.meta) {
                if (this.meta.hasOwnProperty(key))
                    data["Meta"][key] = this.meta[key];
            }
        }
        if (this.settings) {
            data["Settings"] = {};
            for (let key in this.settings) {
                if (this.settings.hasOwnProperty(key))
                    data["Settings"][key] = this.settings[key];
            }
        }
        if (Array.isArray(this.sortOrder)) {
            data["SortOrder"] = [];
            for (let item of this.sortOrder)
                data["SortOrder"].push(item.toJSON());
        }
        if (Array.isArray(this.parameters)) {
            data["Parameters"] = [];
            for (let item of this.parameters)
                data["Parameters"].push(item.toJSON());
        }
        if (Array.isArray(this.imports)) {
            data["Imports"] = [];
            for (let item of this.imports)
                data["Imports"].push(item.toJSON());
        }
        if (Array.isArray(this.references)) {
            data["References"] = [];
            for (let item of this.references)
                data["References"].push(item.toJSON());
        }
        data["Source"] = this.source ? this.source.toJSON() : <any>undefined;
        data["Expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        if (Array.isArray(this.viewFields)) {
            data["ViewFields"] = [];
            for (let item of this.viewFields)
                data["ViewFields"].push(item.toJSON());
        }
        if (Array.isArray(this.viewLanguages)) {
            data["ViewLanguages"] = [];
            for (let item of this.viewLanguages)
                data["ViewLanguages"].push(item.toJSON());
        }
        if (Array.isArray(this.completionRules)) {
            data["CompletionRules"] = [];
            for (let item of this.completionRules)
                data["CompletionRules"].push(item);
        }
        if (Array.isArray(this.completionLanguages)) {
            data["CompletionLanguages"] = [];
            for (let item of this.completionLanguages)
                data["CompletionLanguages"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIQuery {
    iD?: string | undefined;
    fileName?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subType?: string | undefined;
    description?: string | undefined;
    meta?: { [key: string]: string; } | undefined;
    settings?: { [key: string]: string; } | undefined;
    sortOrder?: SortInfo[] | undefined;
    parameters?: QueryParameter[] | undefined;
    imports?: QueryImport[] | undefined;
    references?: QueryReference[] | undefined;
    source?: QuerySource | undefined;
    expression?: Expression | undefined;
    viewFields?: ViewField[] | undefined;
    viewLanguages?: Language[] | undefined;
    completionRules?: number[] | undefined;
    completionLanguages?: Language[] | undefined;
}

export class SortInfo implements ISortInfo {
    field?: string | undefined;
    sortDirection?: SortInfoSortDirection | undefined;

    constructor(data?: ISortInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["Field"];
            this.sortDirection = _data["SortDirection"];
        }
    }

    static fromJS(data: any): SortInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SortInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Field"] = this.field;
        data["SortDirection"] = this.sortDirection;
        return data; 
    }
}

export interface ISortInfo {
    field?: string | undefined;
    sortDirection?: SortInfoSortDirection | undefined;
}

export class QueryParameter implements IQueryParameter {
    name?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    defaultValue?: string | undefined;

    constructor(data?: IQueryParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.typeName = _data["TypeName"];
            this.defaultValue = _data["DefaultValue"];
        }
    }

    static fromJS(data: any): QueryParameter {
        data = typeof data === 'object' ? data : {};
        let result = new QueryParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["TypeName"] = this.typeName;
        data["DefaultValue"] = this.defaultValue;
        return data; 
    }
}

export interface IQueryParameter {
    name?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    defaultValue?: string | undefined;
}

export class QueryImport implements IQueryImport {
    name?: string | undefined;

    constructor(data?: IQueryImport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): QueryImport {
        data = typeof data === 'object' ? data : {};
        let result = new QueryImport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        return data; 
    }
}

export interface IQueryImport {
    name?: string | undefined;
}

export class QueryReference implements IQueryReference {
    name?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;

    constructor(data?: IQueryReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.typeName = _data["TypeName"];
        }
    }

    static fromJS(data: any): QueryReference {
        data = typeof data === 'object' ? data : {};
        let result = new QueryReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["TypeName"] = this.typeName;
        return data; 
    }
}

export interface IQueryReference {
    name?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
}

export class QuerySource implements IQuerySource {
    repository?: string | undefined;
    item?: string | undefined;
    provider?: IQueryProvider | undefined;

    constructor(data?: IQuerySource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repository = _data["Repository"];
            this.item = _data["Item"];
            this.provider = _data["Provider"] ? IQueryProvider.fromJS(_data["Provider"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuerySource {
        data = typeof data === 'object' ? data : {};
        let result = new QuerySource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Repository"] = this.repository;
        data["Item"] = this.item;
        data["Provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IQuerySource {
    repository?: string | undefined;
    item?: string | undefined;
    provider?: IQueryProvider | undefined;
}

export class Expression implements IExpression {
    class?: string | undefined;

    constructor(data?: IExpression) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.class = _data["class"];
        }
    }

    static fromJS(data: any): Expression {
        data = typeof data === 'object' ? data : {};
        let result = new Expression();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["class"] = this.class;
        return data; 
    }
}

export interface IExpression {
    class?: string | undefined;
}

export class ViewField implements IViewField {
    name?: string | undefined;
    systemName?: string | undefined;
    source?: string | undefined;
    sort?: number | undefined;

    constructor(data?: IViewField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.systemName = _data["SystemName"];
            this.source = _data["Source"];
            this.sort = _data["Sort"];
        }
    }

    static fromJS(data: any): ViewField {
        data = typeof data === 'object' ? data : {};
        let result = new ViewField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["SystemName"] = this.systemName;
        data["Source"] = this.source;
        data["Sort"] = this.sort;
        return data; 
    }
}

export interface IViewField {
    name?: string | undefined;
    systemName?: string | undefined;
    source?: string | undefined;
    sort?: number | undefined;
}

export class Language implements ILanguage {
    iD?: string | undefined;
    name?: string | undefined;
    sortOrder?: number | undefined;

    constructor(data?: ILanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iD = _data["ID"];
            this.name = _data["Name"];
            this.sortOrder = _data["SortOrder"];
        }
    }

    static fromJS(data: any): Language {
        data = typeof data === 'object' ? data : {};
        let result = new Language();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ID"] = this.iD;
        data["Name"] = this.name;
        data["SortOrder"] = this.sortOrder;
        return data; 
    }
}

export interface ILanguage {
    iD?: string | undefined;
    name?: string | undefined;
    sortOrder?: number | undefined;
}

export class IQueryProvider implements IIQueryProvider {

    constructor(data?: IIQueryProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IQueryProvider {
        data = typeof data === 'object' ? data : {};
        let result = new IQueryProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IIQueryProvider {
}

export class Language2 implements ILanguage2 {
    _LanguageId?: string | undefined;
    _Code2?: string | undefined;
    _Name?: string | undefined;
    _NativeName?: string | undefined;
    _IsDefault?: boolean | undefined;

    constructor(data?: ILanguage2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._LanguageId = _data["_LanguageId"];
            this._Code2 = _data["_Code2"];
            this._Name = _data["_Name"];
            this._NativeName = _data["_NativeName"];
            this._IsDefault = _data["_IsDefault"];
        }
    }

    static fromJS(data: any): Language2 {
        data = typeof data === 'object' ? data : {};
        let result = new Language2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_LanguageId"] = this._LanguageId;
        data["_Code2"] = this._Code2;
        data["_Name"] = this._Name;
        data["_NativeName"] = this._NativeName;
        data["_IsDefault"] = this._IsDefault;
        return data; 
    }
}

export interface ILanguage2 {
    _LanguageId?: string | undefined;
    _Code2?: string | undefined;
    _Name?: string | undefined;
    _NativeName?: string | undefined;
    _IsDefault?: boolean | undefined;
}

export class DataModel implements IDataModel {
    fields?: DataField[] | undefined;
    name?: string | undefined;
    systemName?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    source?: string | undefined;
    valueMapper?: string | undefined;
    group?: string | undefined;
    operatorTypes?: OperatorTypes[] | undefined;

    constructor(data?: IDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Fields"])) {
                this.fields = [] as any;
                for (let item of _data["Fields"])
                    this.fields!.push(DataField.fromJS(item));
            }
            this.name = _data["Name"];
            this.systemName = _data["SystemName"];
            this.type = _data["Type"];
            this.typeName = _data["TypeName"];
            this.source = _data["Source"];
            this.valueMapper = _data["ValueMapper"];
            this.group = _data["Group"];
            if (Array.isArray(_data["OperatorTypes"])) {
                this.operatorTypes = [] as any;
                for (let item of _data["OperatorTypes"])
                    this.operatorTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): DataModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["Fields"] = [];
            for (let item of this.fields)
                data["Fields"].push(item.toJSON());
        }
        data["Name"] = this.name;
        data["SystemName"] = this.systemName;
        data["Type"] = this.type;
        data["TypeName"] = this.typeName;
        data["Source"] = this.source;
        data["ValueMapper"] = this.valueMapper;
        data["Group"] = this.group;
        if (Array.isArray(this.operatorTypes)) {
            data["OperatorTypes"] = [];
            for (let item of this.operatorTypes)
                data["OperatorTypes"].push(item);
        }
        return data; 
    }
}

export interface IDataModel {
    fields?: DataField[] | undefined;
    name?: string | undefined;
    systemName?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    source?: string | undefined;
    valueMapper?: string | undefined;
    group?: string | undefined;
    operatorTypes?: OperatorTypes[] | undefined;
}

export class DataField implements IDataField {
    name?: string | undefined;
    systemName?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    source?: string | undefined;
    valueMapper?: string | undefined;
    group?: string | undefined;
    operatorTypes?: OperatorTypes2[] | undefined;

    constructor(data?: IDataField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.systemName = _data["SystemName"];
            this.type = _data["Type"];
            this.typeName = _data["TypeName"];
            this.source = _data["Source"];
            this.valueMapper = _data["ValueMapper"];
            this.group = _data["Group"];
            if (Array.isArray(_data["OperatorTypes"])) {
                this.operatorTypes = [] as any;
                for (let item of _data["OperatorTypes"])
                    this.operatorTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): DataField {
        data = typeof data === 'object' ? data : {};
        let result = new DataField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["SystemName"] = this.systemName;
        data["Type"] = this.type;
        data["TypeName"] = this.typeName;
        data["Source"] = this.source;
        data["ValueMapper"] = this.valueMapper;
        data["Group"] = this.group;
        if (Array.isArray(this.operatorTypes)) {
            data["OperatorTypes"] = [];
            for (let item of this.operatorTypes)
                data["OperatorTypes"].push(item);
        }
        return data; 
    }
}

export interface IDataField {
    name?: string | undefined;
    systemName?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    source?: string | undefined;
    valueMapper?: string | undefined;
    group?: string | undefined;
    operatorTypes?: OperatorTypes2[] | undefined;
}

export class DataParameter implements IDataParameter {
    name?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    default?: any | undefined;

    constructor(data?: IDataParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.typeName = _data["TypeName"];
            this.default = _data["Default"];
        }
    }

    static fromJS(data: any): DataParameter {
        data = typeof data === 'object' ? data : {};
        let result = new DataParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["TypeName"] = this.typeName;
        data["Default"] = this.default;
        return data; 
    }
}

export interface IDataParameter {
    name?: string | undefined;
    type?: string | undefined;
    typeName?: string | undefined;
    default?: any | undefined;
}

export class TokenRequestModel implements ITokenRequestModel {
    userName?: string | undefined;
    password?: string | undefined;
    deviceId?: string | undefined;

    constructor(data?: ITokenRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["UserName"];
            this.password = _data["Password"];
            this.deviceId = _data["DeviceId"];
        }
    }

    static fromJS(data: any): TokenRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new TokenRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserName"] = this.userName;
        data["Password"] = this.password;
        data["DeviceId"] = this.deviceId;
        return data; 
    }
}

export interface ITokenRequestModel {
    userName?: string | undefined;
    password?: string | undefined;
    deviceId?: string | undefined;
}

export enum DataItemTypeViewMode {
    _0 = 0,
    _1 = 1,
}

export enum FacetVisibilityStatus {
    _1 = 1,
    _2 = 2,
}

export enum FacetVisibilityCondition {
    _1 = 1,
    _2 = 2,
}

export enum IIndexBuilderNotificationNotificationType {
    Never = "Never",
    EveryTime = "EveryTime",
    OnFailure = "OnFailure",
}

export enum SortInfoSortDirection {
    Ascending = "Ascending",
    Descending = "Descending",
}

export enum OperatorTypes {
    GreaterThan = "GreaterThan",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    LessThan = "LessThan",
    LessThanOrEqual = "LessThanOrEqual",
    Equal = "Equal",
    MatchAny = "MatchAny",
    MatchAll = "MatchAll",
    Contains = "Contains",
    ContainsExtended = "ContainsExtended",
    In = "In",
    Between = "Between",
    And = "And",
    Or = "Or",
    IsEmpty = "IsEmpty",
}

export enum OperatorTypes2 {
    GreaterThan = "GreaterThan",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    LessThan = "LessThan",
    LessThanOrEqual = "LessThanOrEqual",
    Equal = "Equal",
    MatchAny = "MatchAny",
    MatchAll = "MatchAll",
    Contains = "Contains",
    ContainsExtended = "ContainsExtended",
    In = "In",
    Between = "Between",
    And = "And",
    Or = "Or",
    IsEmpty = "IsEmpty",
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}